import { render, staticRenderFns } from "./VJZAXGJW.vue?vue&type=template&id=d71602d2&scoped=true&"
import script from "./VJZAXGJW.vue?vue&type=script&lang=js&"
export * from "./VJZAXGJW.vue?vue&type=script&lang=js&"
import style0 from "./VJZAXGJW.vue?vue&type=style&index=0&id=d71602d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d71602d2",
  null
  
)

export default component.exports